export default class aeAccordion {
    constructor() {
        let self = this;
        self._process();
    }

    _process(){
        let self = this;
        $('[data-ae-accordion]').each(function () {
            self._binding($(this), $(this).find('.accordion-toggle'));
        });
    }


    _binding(ele, toggleEle){
        toggleEle.click(function () {
            if (toggleEle.attr('aria-expanded') == 'true') {
                if (window.location.hash == ('#' + ele.attr('id'))) {
                    history.replaceState(null, null, document.location.pathname);
                }
                toggleEle.attr('aria-expanded', 'false');
                toggleEle.next().attr('aria-hidden', 'true');
            } else {
                history.replaceState(null, null, document.location.pathname + '#' + ele.attr('id'));
                toggleEle.attr('aria-expanded', 'true');
                toggleEle.next().attr('aria-hidden', 'false');
            }
        });
    }


    handleOpenCloseGlobal(){

        var toggleAllMarkup = ''+
            '<div class="accordion-open-close-btns">'+
            '<button class="accordion-open-all" aria-label="Close all expanders in the preceding list"><i class="fa fa-folder" aria-hidden="true"></i> Close </button>'+
            '<button class="accordion-close-all" aria-label="Open all expanders in the preceding list"> <i class="fa fa-folder-open" aria-hidden="true"></i> Open</button>'+
            '</div>';

        var groupingI = 1;

        $('.accordion-wrapper').each(function () {
            var parentEle = $(this);
            var currentEle = parentEle;
            if (!currentEle.is('[data-accordion-wrapper-group]')) {
                while (
                    currentEle.next().hasClass('accordion-wrapper')
                    ) {
                    currentEle = currentEle.next();
                    currentEle.addClass('accordion-wrapper-grouped');
                    currentEle.attr('data-accordion-wrapper-group', groupingI);
                }
                if (!currentEle.is(parentEle)) {
                    parentEle.attr('data-accordion-wrapper-group', groupingI);
                    groupingI++;
                }
            }
        });
        let i = 1
        while(i <= groupingI) {
            let groupEles = $('[data-accordion-wrapper-group="' + i + '"]');
            if (groupEles.length) {
                var groupLiEles = [];
                groupEles.each(function () {
                    $(this).wrap('<li>');
                    groupLiEles.push($(this).parent());
                });
                groupLiEles = $(groupLiEles).map(function () {return this.toArray(); } );

                $(groupLiEles).wrapAll('<ul>');
                let primayGroup = groupLiEles.first().parent();
                primayGroup.wrapAll('<div class="accordion-wrapper-group-wrapper">');
                primayGroup = primayGroup.parent();
                primayGroup.prepend(toggleAllMarkup);
            }
            i++;
        }

        $('.accordion-open-all').click(function () {
            $(this).closest('.accordion-wrapper-group-wrapper').find('.accordion-toggle[aria-expanded="true"]').each(function () {
                $(this).click();
            });
        });
        $('.accordion-close-all').click(function () {
            $(this).closest('.accordion-wrapper-group-wrapper').find('.accordion-toggle[aria-expanded="false"]').each(function () {
                $(this).click();
            });
        });


        $('.accordion-content').each(function () {
            if($(this).find(':last-child').css('margin-bottom') == '0px') {
                $(this).addClass('accordion-content-margin-bottom');
            }
        });




    }


}